import React from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import NavMenu from './NavMenu';
import Footer from './footer/Footer';
import ScrollToTop from './ScrollToTop';
import BackAltered from './backaltered/BackAltered';

import { resources } from '../../i18n/i18n';
import Cookie from './Cookie';

const registerPageLoad = () => {

    var _paq = window._paq || [];
    _paq.push(['setCustomUrl', window.location.hash]);
    _paq.push(['setDocumentTitle', window.location.pathname]);
    if (localStorage.getItem('cookie') === "false") {
        _paq.push(['disableCookies']);
    }
    _paq.push(['trackPageView']);
};

const Layout = (): React.JSX.Element => { 

    const {t, i18n} = useTranslation();
    let location = useLocation();
    const segments = location.pathname.split('/').filter(Boolean);
    const langue = segments[0];
    const page = segments[1];

    React.useEffect(() => {
        const metaDescription = document.querySelector('meta[name="description"]');
        const title = document.querySelector('title');
        if (metaDescription) {
            metaDescription.setAttribute('content', t('MetaDescription'));
        }
        if (title) {
            title.innerText = t('MetaDescription');
        }
    }, [i18n.language, t]);

    React.useEffect(() => {
        registerPageLoad();
    }, [location]);


    React.useEffect(()=>{
        let lang = "en";
        lang = localStorage.getItem("lang") === undefined ? navigator.language : localStorage.getItem("lang")!;
        if (!Object.keys(resources).includes(lang))
            lang = "en";
        i18n.changeLanguage(lang);
        localStorage.setItem("lang", i18n.language);
    }, [i18n]);

    const schema = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": t('MetaDescription'),
        "provider": {
            "@type": "Organization",
            "name": "Flowly",
            "url": `https://www.flowly.ai/${langue}`
        },
        "url": `https://www.flowly.ai${location.pathname}`
    };

    return (
            <HelmetProvider>
        <div className="b-alt">
                <Helmet>
                    <title>Flowly</title>
                    <script type="application/ld+json">
                        {JSON.stringify(schema)}
                        </script>
                </Helmet>
            <BackAltered />
            <ScrollToTop />
            <NavMenu />
            <Outlet />
            <Cookie activate={true}/>
            <Footer />
        </div>
            </HelmetProvider>
    );
};

export default Layout;
